import React from "react";

export default function EmptyState({ canEdit = false, onStart }) {
    return (
        <div className="td-empty">
            <div className="td-empty-card">
                <h3>No versions yet</h3>
                <p>
                    Start the first version of this Technical Documentation to build its
                    structure and content — from scratch or from a template.
                </p>
                {canEdit && onStart && (
                    <button className="td-btn td-btn-primary" style={{ marginTop: 16 }} onClick={onStart}>
                        <i className="fas fa-plus-circle" /> Start first version
                    </button>
                )}
            </div>
        </div>
    );
}
